<div class="container-idle show">
  <div class="modal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1>{{ isCreating ? 'Agregar' : 'Editar' }} cuenta bancaria</h1>
          <h1 class="i-hover" style="left: 0;"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
        </div>

        <div class="modal-body">
          <div id="container" class="mt-4">

            <div class="row mb-3">
              <div class="col-sm form-group">
                <label for="vendorBankSelect">Seleccionar cuenta bancaria</label>
                <select class="form-select" (change)="onSelectVendorBank($event)">
                  <option [value]="-1">Agregar nueva cuenta</option>
                  <option *ngFor="let vb of vendorBanks" [value]="vb.id">
                    {{ vb.accountNumber }} - {{ getBankNameById(vb.idBank) }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-sm form-group">
                <label for="accountNumber">Número de cuenta <span class="required">*</span></label>
                <input class="form-control" [(ngModel)]="vendorBank.accountNumber" placeholder="Ej. 1234567890" />
              </div>

              <div class="col-sm form-group">
                <label for="typeBank">Tipo de cuenta</label>
                <select class="form-select" [(ngModel)]="vendorBank.typeBank">
                  <option [value]="1">Monetaria</option>
                  <option [value]="2">Ahorro</option>
                </select>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-sm form-group">
                <label for="idBank">Banco <span class="required">*</span></label>
                <select class="form-select" [(ngModel)]="vendorBank.idBank">
                  <option *ngFor="let bank of banks" [value]="bank.id">{{ bank.name }}</option>
                </select>
              </div>

              <div class="col-sm-3 form-group">
                <label for="typeBank">Alcance</label>
                <select class="form-select" [(ngModel)]="vendorBank.international">
                  <option [value]="false">Local</option>
                  <option [value]="true">Internacional</option>
                </select>
              </div>
            </div>

            <div class="button-container text-end">
              <button class="btn btn-success"
                      (click)="save()"
                      [disabled]="!vendorBank.idBank || loading">
                <ng-container *ngIf="!loading">
                  <i class="fa fa-floppy-disk"></i>
                  {{ isCreating ? 'GUARDAR' : 'GUARDAR CAMBIOS' }}
                </ng-container>
                <ng-container *ngIf="loading">
                  <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                </ng-container>
              </button>
            </div>

          </div>
        </div>

        <div class="modal-footer">
          <p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;">
            <i class="fa fa-circle-info"></i>
            Completa los campos marcados con <span class="required">*</span> para {{ isCreating ? 'guardar' : 'modificar' }} la cuenta bancaria
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
